import React from 'react';
import { Briefcase } from 'lucide-react';
import { WorkBenefits } from './WorkBenefits';
import { WorkRequirements } from './WorkRequirements';
import { WorkApplicationForm } from './WorkApplicationForm';

export const WorkPage: React.FC = () => {
  return (
    <div className="min-h-screen p-6">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center">
          <div className="w-20 h-20 bg-purple-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
            <Briefcase className="w-10 h-10 text-purple-300" />
          </div>
          <h1 className="text-3xl font-bold text-purple-200 mb-2">
            Trabalhe Conosco
          </h1>
          <p className="text-purple-200/70 text-lg">
            Junte-se à nossa equipe de especialistas em astrologia
          </p>
        </div>

        <WorkBenefits />
        <WorkRequirements />
        <WorkApplicationForm />
      </div>
    </div>
  );
};